// extracted by mini-css-extract-plugin
export default {"wrapper":"Margin_wrapper__ZQLIn","H":"Margin_H__dQATf","V":"Margin_V__1no6B"};